import { UseFormReturn } from 'react-hook-form';

import { QuickQuoteInputs } from '../../types';
import { QuoteInformationSection as LTLQuoteInformationSection } from '../QuoteInformationSection';

interface QuoteInformationSectionProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
}

/**
 * Tai Quote Information for LTL Quick Quote.
 * Includes Customer Staff (Quote Contact) selection.
 */
export function QuoteInformationSection({
  formMethods,
}: QuoteInformationSectionProps) {
  return <LTLQuoteInformationSection formMethods={formMethods} />;
}
